var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.163.644c-.86-.859-2.253-.859-3.114 0l-.779.784L1.974 9.72l-.018.018c-.004.004-.004.009-.008.009-.01.013-.022.026-.031.04 0 .004-.005.004-.005.008l-.022.035-.008.014c-.005.013-.01.022-.014.035 0 .004-.004.004-.004.009l-1.84 5.535c-.055.158-.014.332.105.45.083.081.196.127.313.127.048 0 .095-.008.14-.022l5.531-1.845c.005 0 .005 0 .01-.005.013-.004.026-.01.039-.017.003 0 .006-.002.009-.005l.044-.026c.013-.009.026-.022.04-.03.004-.005.008-.005.008-.01.004-.004.013-.008.018-.017l9.075-9.076c.859-.86.859-2.254 0-3.114L14.163.644zm-8.19 12.454l-3.065-3.065 7.67-7.671 3.065 3.064-7.67 7.672zm-3.497-2.25l2.677 2.677-4.02 1.339 1.343-4.016zm12.26-6.518l-.468.471-3.064-3.065.47-.471c.516-.515 1.352-.515 1.868 0l1.197 1.198c.512.518.51 1.351-.004 1.867z",
    transform: "translate(-384 -396) translate(384 396)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditWhite);
export default __webpack_public_path__ + "static/media/ic_edit_white.336e52a99521cc31db42eef3d1828495.svg";
export { ForwardRef as ReactComponent };